export const PERMISSION_GROUP = {
    PEOPLE: 'People',
    PAYER: "Payer",
    RECIPIENT: "Recipient",
    USER: "User",
    TIN: "TIN",
    IMPORT_DATA: "ImportData",
    FORMS: "Forms",
    PAYMENT: "Payment",
    EVENTS: "Events",
}

export const USER_LOADING_STATES = {
    GRID_LOADING: "GRID_LOADING",
    GRID_READY: "GRID_READY",
    EXPORT_LOADING: "EXPORT_LOADING",
    EXPORT_READY: "EXPORT_READY",
    GENERAL_LOADING: "GENERAL_LOADING",
    GENERAL_READY: "GENERAL_READY",
    STATUS_LOADING: "STATUS_LOADING",
    STATUS_READY: "STATUS_READY",
    IMPORT_LOADING: "TEMPLATE_LOADING",
    IMPORT_READY: "TEMPLATE_READY",
    ACTIONS_LOADING: "ACTIONS_LOADING",
    ACTIONS_READY: "ACTIONS_READY",
    ASSIGN_PAYER_LOADING: "ASSING_PAYER_LOADING",
    ASSIGN_PAYER_READY: "ASSING_PAYER_READY",
    ASSING_MEMBER_LOADING: "ASSING_MEMBER_LOADING",
    ASSING_MEMBER_READY: "ASSING_MEMBER_READY",
    PAYERS_LIST_LOADING: "PAYERS_LIST_LOADING",
    PAYERS_LIST_READY: "PAYERS_LIST_READY",
    PAYER_GROUP_LOADING: "PAYER_GROUP_LOADING",
    PAYER_GROUP_READY: "PAYER_GROUP_READY",
    PAYER_GROUP_FILTER_LOADING: "PAYER_GROUP_FILTER_LOADING",
    PAYER_GROUP_FILTER_READY: "PAYER_GROUP_FILTER_READY",
}

export const USER_MESSAGE_MAP = {
    [USER_LOADING_STATES.GRID_LOADING]: "",
    [USER_LOADING_STATES.GRID_READY]: "",
    [USER_LOADING_STATES.EXPORT_LOADING]: "",
    [USER_LOADING_STATES.EXPORT_READY]: "",
    [USER_LOADING_STATES.GENERAL_LOADING]: "",
    [USER_LOADING_STATES.GENERAL_READY]: "",
    [USER_LOADING_STATES.STATUS_LOADING]: "",
    [USER_LOADING_STATES.STATUS_READY]: "",
    [USER_LOADING_STATES.IMPORT_LOADING]: "",
    [USER_LOADING_STATES.IMPORT_READY]: "",
    [USER_LOADING_STATES.ACTIONS_LOADING]: "",
    [USER_LOADING_STATES.ACTIONS_READY]: "",
    [USER_LOADING_STATES.ASSIGN_PAYER_LOADING]: "",
    [USER_LOADING_STATES.ASSIGN_PAYER_READY]: "",
    [USER_LOADING_STATES.ASSING_MEMBER_LOADING]: "",
    [USER_LOADING_STATES.ASSING_MEMBER_READY]: "",
}